module.exports = import("/module-migration/client/remoteEntry.js");